module.exports = __webpack_public_path__ + "5c8730035693d5e65267b73efd7716a1.MP3";